// extracted by mini-css-extract-plugin
export var changeIcon = "_4a-4";
export var container = "_4a-0";
export var divider = "_4a-7";
export var externalLinkIcon = "_4a-1";
export var green = "_4a-5";
export var helpCircleIcon = "_4a-3";
export var iconButton = "_4a-2";
export var red = "_4a-6";